import { render } from "./SentenceNotebook.vue?vue&type=template&id=4101cbf2&scoped=true"
import script from "./SentenceNotebook.vue?vue&type=script&lang=js"
export * from "./SentenceNotebook.vue?vue&type=script&lang=js"

import "./SentenceNotebook.vue?vue&type=style&index=0&id=4101cbf2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4101cbf2"]])

export default __exports__